var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22653 1.89585C8.95162 1.62086 8.57874 1.46633 8.18991 1.46625H2.93204C2.54318 1.46625 2.17024 1.62072 1.89527 1.89569C1.6203 2.17066 1.46582 2.5436 1.46582 2.93247V8.19034C1.4659 8.57917 1.62043 8.95205 1.89542 9.22695L8.27642 15.6079C8.60962 15.9391 9.06029 16.1249 9.53004 16.1249C9.99978 16.1249 10.4504 15.9391 10.7837 15.6079L15.6075 10.7841C15.9386 10.4509 16.1245 10.0002 16.1245 9.53046C16.1245 9.06072 15.9386 8.61005 15.6075 8.27684L9.22653 1.89585Z",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49839 5.86489C5.70083 5.86489 5.86495 5.70077 5.86495 5.49833C5.86495 5.29589 5.70083 5.13177 5.49839 5.13177C5.29595 5.13177 5.13184 5.29589 5.13184 5.49833C5.13184 5.70077 5.29595 5.86489 5.49839 5.86489Z",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5947,
    height: 17.5947,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.eebade8d5b2c10cb2b021cac47ec8416.svg";
export { ForwardRef as ReactComponent };